import { tryCheckRecipientPermission } from './tryCheckRecipientPermissionForOneLink';
import { isFeatureEnabled } from 'owa-feature-flags';
import { SharingTipRecipientInfo } from 'owa-sharing-data';

export async function tryCheckRecipientPermissionForLinks(
    linkIds: string[],
    recipientInfo: SharingTipRecipientInfo[]
) {
    if (!isFeatureEnabled('doc-recipient-permission')) {
        return;
    }

    linkIds.forEach(linkId => {
        tryCheckRecipientPermission(linkId, recipientInfo);
    });
}
